<template>
  <nav class="flex relative">
    <div
      data-jest="user-menu-trigger"
      role="button"
      aria-label="User Menu"
      class="flex flex-row items-center font-light cursor-pointer"
      @click="toggleMenu"
    >
      <div class="flex flex-row items-center">
        <kudo-button
          shape-variant="round"
          color-variant="secondary"
          :style="{ backgroundImage: `url(${ avatarUrl }` }"
          class="mr-4 bg-cover block"
        />
        <i
          :class="{ 'rotate-180': isOpen }"
          class="fas fa-chevron-down transform transition-transform duration-300"
        />
      </div>
    </div>
    <div
      :class="{ 'opacity-0 scale-y-95 pointer-events-none': !isOpen }"
      class="absolute right-0 top-[47px] w-auto whitespace-nowrap rounded-md bg-white transform origin-top-right transition-all duration-300 ease-in-out z-10 shadow-[0px_4px_8px_3px_rgba(0,0,0,0.15),0px_1px_3px_0px_rgba(0,0,0,0.30)]"
    >
      <div class="flex gap-x-2 items-center py-4 px-6">
        <div
          class="rounded-full w-10 h-10 bg-cover"
          :style="{ backgroundImage: `url(${ avatarUrl }` }"
        />
        <div class="flex flex-col">
          <p class="text-sm font-semibold">
            {{ firstName }} {{ lastName }}
          </p>
          <p class="text-xs text-gray-dark">
            {{ email }}
          </p>
        </div>
      </div>
      <div class="mx-6 bg-gray-lighter h-px" />
      <div class="flex flex-col py-2">
        <button
          class="user-menu-item"
          @click="openHelpCenter"
        >
          <i class="fa-regular fa-question user-menu-icon" />
          <span class="text-sm">Help Center</span>
        </button>
        <button
          class="user-menu-item"
          @click="openChat"
        >
          <i class="fa-regular fa-message user-menu-icon" />
          <span class="text-sm">Chat</span>
        </button>
        <button
          class="user-menu-item"
          @click="openAgencyResources"
        >
          <i class="fa-regular fa-book-blank user-menu-icon" />
          <span class="text-sm">Agency Resources</span>
        </button>
      </div>
      <div class="mx-6 bg-gray-lighter h-px" />
      <div class="flex flex-col py-2">
        <nuxt-link
          class="user-menu-item"
          to="/admin/settings"
        >
          <i class="fa-regular fa-gear user-menu-icon" />
          <span class="text-sm">Settings</span>
        </nuxt-link>
        <button
          class="user-menu-item"
          @click="logout"
        >
          <i class="fa-regular fa-arrow-right-from-bracket user-menu-icon" />
          <span class="text-sm">Logout</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { KudoButton } from '@openly-engineering/kudo'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    KudoButton,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapState('self', ['avatarUrl', 'firstName', 'lastName', 'email']),
  },
  mounted() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false
      }
    })
  },
  methods: {
    ...mapActions('self', ['logout']),
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    openHelpCenter() {
      this.trackNavItemEvent('Help Center')
      window.open('https://help.openly.com/hc/en-us', '_blank')
    },
    openChat() {
      this.$chat.openChat()
      this.trackNavItemEvent('Chat')
    },
    async openAgencyResources() {
      await this.trackNavItemEvent('Agency Resources')
      window.open('https://help.openly.com/hc/en-us/articles/15532386227479-Agent-Resources', '_blank', 'noopener,noreferrer')
    },
    async trackNavItemEvent(item) {
      await window.analytics.track('User Nav Item Click', {
        'Nav Item': item,
      })
    },
  },
}
</script>

<style scoped>
  .user-menu-item {
    @apply flex gap-x-3 items-center py-2 px-6;
  }
  .user-menu-item:hover {
    @apply bg-plum-lightest;
  }
  .user-menu-icon {
    @apply w-4 h-4;
  }
</style>
